import React from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import passion from "./../images/passion.jpeg";
import account from "./../images/accout.jpeg";
import leader from "./../images/leader.jpeg";
import collabe from "./../images/collabe.jpeg";
import quality from "./../images/quality.jpeg";

import useMediaQuery from "@mui/material/useMediaQuery";

const Values = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        flexGlow: 1,
        padding: vMediaQuery ? "20px 18px" : "40px 140px",
        textAlign: "center",
      }}
    >
      <h1 style={{ color: "#357ec7", fontSize: vMediaQuery ? "20px" : "34px" }}>
        Our Values
      </h1>
      <Typography variant="body1">
        Our values serve as a compass for our actions and validate how we <br />
        operate as people and a company.
      </Typography>

      <Grid
        container
        spacing={0}
        sx={{ padding: vMediaQuery ? "0px" : "0px 40px" }}
      >
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={leader} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "24px" }}
            >
              <strong>Leadership</strong>
            </Typography>
            <Typography variant="body2">
              {" "}
              The ability to own a <br /> vision and the fortitude
              {vMediaQuery || <br />} to execute that vision
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanier">
              <img className="values" alt="certificates" src={passion} />
            </div>
            <Typography variant="body2">
              <strong>Passion</strong>
            </Typography>
            <Typography variant="body2">
              Being committed <br />
              inside and out
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={collabe} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "26px" }}
            >
              <strong>Collaboration</strong>
            </Typography>
            <Typography variant="body2">
              To leverage our <br />
              collective intellect
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierLCQ">
              <img className="valuesLCQ" alt="certificates" src={account} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "22px" : "34px" }}
            >
              <strong>Accountability</strong>
            </Typography>
            <Typography variant="body2">
              Taking pride <br /> and ownership
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md={4} lg={2.4}>
          <Stack>
            <div className="values-contanierQ">
              <img className="valuesQ" alt="certificates" src={quality} />
            </div>
            <Typography
              variant="body2"
              sx={{ marginTop: vMediaQuery ? "17px" : "20px" }}
            >
              <strong>Quality</strong>
            </Typography>
            <Typography variant="body2">
              What we do, we <br />
              do well
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Values;
